angular.module('impactx.search').controller('ProductGroupSearchListCtrl', [
    ProductGroupSearchListCtrl
]);

function ProductGroupSearchListCtrl() {

}
